import api from './api'

export default {
  purchases(filiationBalanceId, params) {
    return api.get(
      `/admin/filiation-balances/${filiationBalanceId}/purchases`,
      { params },
    )
  },
  subscriptions(filiationBalanceId, params) {
    return api.get(
      `/admin/filiation-balances/${filiationBalanceId}/subscriptions`,
      { params },
    )
  },
  videoWatches(filiationBalanceId, params) {
    return api.get(
      `/admin/filiation-balances/${filiationBalanceId}/video-watches`,
      { params },
    )
  },
  list(params) {
    return api.get('/admin/filiation-balances', { params })
  },

  refresh(id) {
    return api.post(`/admin/filiation-balances/${id}/refresh`)
  },

  closeMonth(month) {
    return api.post('admin/filiation-balances/close-month', { month })
  },
}
